import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import HoverHelpTextIcon from '../../HoverHelpTextIcon'

import { isNewStylesThemeEnabledSelector } from '../../../../modules/selectors/app'

import useStyles from './styles'
import * as classes from './styles.css'

function FieldLabelWrapper({
  label,
  labelFor,
  className,
  contentClassName,
  children,
  labelClassName,
  description,
  helpText,
  horizontalView = false
}) {
  const legacyClasses = useStyles()
  const isNewStylesThemeEnabled = useSelector(isNewStylesThemeEnabledSelector)

  const vanillaClasses = {
    ...classes,
    fieldContent: classes.fieldContent({ direction: horizontalView ? 'horizontal' : 'vertical' }),
    fieldWrapper: classes.fieldWrapper({ direction: horizontalView ? 'horizontal' : 'vertical' })
  }

  const activeClasses = isNewStylesThemeEnabled ? vanillaClasses : legacyClasses

  return (
    <div className={classnames(activeClasses.fieldWrapper, className)}>
      <div>
        <label className={classnames(activeClasses.fieldLabel, labelClassName)} htmlFor={labelFor}>
          {label} {helpText && <HoverHelpTextIcon helpText={helpText} />}
        </label>
        {description && <p className={activeClasses.description}>{description}</p>}
      </div>
      <div className={classnames(activeClasses.fieldContent, contentClassName)}>{children}</div>
    </div>
  )
}

FieldLabelWrapper.propTypes = {
  label: PropTypes.string.isRequired,
  labelFor: PropTypes.string,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  description: PropTypes.string,
  helpText: PropTypes.string,
  horizontalView: PropTypes.bool
}

export default FieldLabelWrapper
